import React, { useEffect, useMemo, useState } from "react";
import PolicyHeroCard from "./PolicyHeroCard";
import Breadcrumb from "./Breadcrumb";
import Tabs from "../../../components/common/tabs/tabs.jsx";
import AnimatedTabContent from "../../../components/common/animatedTabContent/animatedTabContent";
import {
  tabs,
  policyInfo,
  fundPerformanceData,
  overviewTabData,
  paymentsHistoryData,
  BREADCRUMP_ITEMS,
  findPlanType,
  BUY_ONLINE_PLANS,
  PROTECTION_PLANS,
  SAVING_PROTECTION,
} from "./data.js";
import FundPerformance from "./fundPerformance/fundPerformance.jsx";
import OverviewTab from "./OverviewTab/OwerviewTab.jsx";
import PaymentHistory from "./paymentHistory/paymentHistory.jsx";
import FundManagement from "./fundManagementTab/fundManagement.jsx";
import ManagePolicyTab from "./manageMyPolicy/managePolicyTab.jsx";
import useScreenResolution from "../../../hooks/useScreenResolution.js";
import MobileFooter from "../../../components/common/sideNavbar/mobileFooter";
import useLifePolicyDetails from "../../../hooks/life/useLifePolicyDetails.js";

import { createPortal } from "react-dom";
import BackdropModal from "../../../components/common/modal/backdropModal.jsx";
import DownloadBtn from "../../../components/common/downloadBtn/downloadBtn.jsx";
import { decryptPolicyNumber } from "../../../utils/index.js";
import { useSearchParams } from "react-router-dom";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate.js";
import { useTranslation } from "react-i18next";
import LifePolicyOverviewSkeleton from "./LifePolicyOverviewSkeleton.jsx";

const PolicyOverview = () => {
  const [searchParams] = useSearchParams();
  const decodedQueryString = Object.fromEntries(searchParams.entries());
  const { data, isLoading } = useLifePolicyDetails(decryptPolicyNumber(decodedQueryString?.policy));
  const policyStatus = searchParams.get("status");
  const translate  = useLanguageTranslate();

  const [breadCrumbData, setBreadCrumbData] = useState(BREADCRUMP_ITEMS);
  const [activeTab, setActiveTab] = useState("PolicyOverview");
  const [downloadMenuClicked, setDownloadMenuClicked] = useState(false);
  const screenResolution = useScreenResolution();
  const {i18n} = useTranslation()
  const toggleDownloadMenuClicked = () => {
    setDownloadMenuClicked(!downloadMenuClicked);
  };
  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "PolicyOverview":
        return (
          <OverviewTab
            cards={overviewTabData.cards}
            info={data}
            chngBeneficiaryCardData={overviewTabData.chngBeneficiaryCard}
            downloadCardData={data?.Reports}
            tableData={overviewTabData.table}
            handleDownloadMenuClicked={toggleDownloadMenuClicked}
          />
        );
      case "FundPerformance":
        return (
          <FundPerformance
            cardsData={fundPerformanceData.cards}
            info={data}
            chartsData={fundPerformanceData.charts}
          />
        );
      case "PaymentsHistory":
        return <PaymentHistory info={data} />;
      case "FundManagement":
        return <FundManagement />;
      case "ManagePolicy":
        return <ManagePolicyTab info={data} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    setBreadCrumbData([
      {
        label: translate("My Policy","وثيقتي"),
        link: "/my-policy",
        clickable: true,
        name: 'my_policy'
      },
      {
        label: data?.PolicyDetails?.ProductName,
        clickable: false,
        name: "current_plan",
        isActive: true,
      },
    ]);
  }, [i18n?.resolvedLanguage,data]);

  const tabTypeParam = searchParams.get("tabType");

  useEffect(() => {
    if (tabTypeParam) {
      setActiveTab(tabTypeParam);
    }
  }, [tabTypeParam]);

  const disabledTabs = useMemo(()=>{
    let disableData = []
     if(policyStatus =="EXPIRED") {
      disableData.push("ManagePolicy")
     }
     let planType = findPlanType(data?.PolicyDetails?.ProductCode) || SAVING_PROTECTION
     if(planType===BUY_ONLINE_PLANS){
      disableData.push("FundManagement")
      disableData.push("PaymentsHistory")
      disableData.push("FundPerformance")
      //disableData.push("ManagePolicy")
     }
     else if (planType===PROTECTION_PLANS){
        disableData.push("FundPerformance")
        disableData.push("FundManagement")
     }
     return disableData
  },[data])

  if (isLoading) return <LifePolicyOverviewSkeleton />;

  return (
    <div className="p-6 max767:p-0 max767:m-0">
      <div className="flex justify-between items-center">
        {!screenResolution.mobile && <Breadcrumb items={breadCrumbData} />}
        {/* {!screenResolution.mobile && (
          <span className="hidden last-login text-xs not-italic font-normal leading-4 text-gray-700">
            Last Login: 03 November 2024 at 05:20{" "}
          </span>
        )} */}
      </div>

      <PolicyHeroCard
        info={{ ...decodedQueryString, policy: decryptPolicyNumber(decodedQueryString?.policy) }}
        content={data}
        handleDownloadMenuClicked={toggleDownloadMenuClicked}
      />
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={setActiveTab}
        disabledTabs={disabledTabs || []}
      />
      <AnimatedTabContent activeTab={activeTab} order={tabs.map((t) => t.type)}>
        {renderActiveTabContent()}
      </AnimatedTabContent>
      {screenResolution.mobile && <MobileFooter />}
      {createPortal(
        <div className="downloaddocumentsmodal">
          <BackdropModal
            show={downloadMenuClicked}
            onClose={toggleDownloadMenuClicked}
            title={translate("Download Documents", "تحميل المستندات")}
          >
            <div className="flex-row">
              <DownloadBtn filesData={data?.Reports} className={"mb-2"} />
            </div>
          </BackdropModal>
        </div>,
        document.body
      )}
    </div>
  );
};

export default PolicyOverview;
